<template>
  <detail-template :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-maybay-state
            v-if="hcFlowInstance"
            :state="hcFlowInstance.currentStateCode"
          />
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >
            Yêu cầu đăng ký vé máy bay
          </div>
          <div class="margin-top-10" v-if="!!requestUserDeptRole">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{
                requestUserDeptRole.deptName
              }}</span>
          </div>
          <div
            class="margin-top-10 padding-bottom-10 flex-row has-border__bottom"
            v-if="hcCaseFlight && requestUserDeptRole"
          >
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{
                  requestUserDeptRole.fullName
                }}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <el-date-picker
              size="medium"
              class="input-none__border input-border__radius__0 padding-left-0 el-date-picker-bold"
              v-model="hcCaseFlight.createTime"
              placeholder="dd/mm/yyyy"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              :prefix-icon="' '"
              :readonly="true"
            ></el-date-picker>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="150px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin yêu cầu
                  </div>

                  <el-form-item label="Tên yêu cầu" prop="requestName">
                    <el-input
                      v-model="form.requestName"
                      placeholder="Tên yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="100"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Nội dung yêu cầu" prop="requestContent">
                    <el-input
                      type="textarea"
                      v-model="form.requestContent"
                      placeholder="Nội dung yêu cầu"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="500"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>

                  <hc-maybay-upload-readonly
                    v-if="!!hcCaseFlight"
                    :hcCaseMasterId="caseMasterId"
                    :hcCaseFlightFileType="HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH"
                    :hcCaseFlightId="hcCaseFlight.id"
                  ></hc-maybay-upload-readonly>

                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin bay
                  </div>

                  <hc-maybay-upload-readonly
                    v-if="!!hcCaseFlight"
                    :hcCaseMasterId="caseMasterId"
                    :hcCaseFlightFileType="HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY"
                    :hcCaseFlightId="hcCaseFlight.id"
                  ></hc-maybay-upload-readonly>

                  <hc-maybay-user-route-readonly
                    :hcCaseMasterId="caseMasterId"
                  ></hc-maybay-user-route-readonly>

                  <el-form-item
                    label="Ghi chú"
                    prop="note"
                    class="margin-top-5"
                  >
                    <el-input
                      type="textarea"
                      v-model="form.note"
                      placeholder="Ghi chú"
                      class="input-border__bottom input-border__radius__0 style-fullWidth"
                      size="medium"
                      maxlength="500"
                      show-word-limit
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </VuePerfectScrollbar>

      <div
        class="footer"
        v-if="
          isAbleToCapNhat || isAbleToHuy || isAbleToPheDuyet || isAbleToTuChoi
        "
      >
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToCapNhat"
              @click="update"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToPheDuyet"
              @click="approve"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Phê duyệt
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToTuChoi"
              @click="reject"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              v-if="isAbleToHuy"
              @click="cancel"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Hủy
            </el-button>

            <el-button
              size="medium"
              class="addDocs color__white bg__blue btn-none__border"
              @click="exportReport"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Xuất excel
            </el-button>
          </div>
        </div>
      </div>

      <hc-maybay-approve-dialog
        v-if="!!hcCaseFlight && isEnableDialogApprove"
        :isOpen="isOpenDialogApprove"
        :id="hcCaseFlight.id"
        @dialogClosed="isEnableDialogApprove = false"
        @closeDialog="isOpenDialogApprove = false"
        @approveSuccess="approveSuccess"
      />

      <hc-maybay-update-dialog
        v-if="!!hcCaseFlight && isEnableDialogUpdate"
        :isOpen="isOpenDialogUpdate"
        :id="hcCaseFlight.id"
        @dialogClosed="isEnableDialogUpdate = false"
        @closeDialog="isOpenDialogUpdate = false"
        @updateSuccess="updateSuccess"
      />

      <hc-maybay-reject-dialog
        v-if="!!hcCaseFlight && isEnableDialogReject"
        :isOpen="isOpenDialogReject"
        :id="hcCaseFlight.id"
        @dialogClosed="isEnableDialogReject = false"
        @closeDialog="isOpenDialogReject = false"
        @rejectSuccess="rejectSuccess"
      />

      <hc-maybay-cancel-dialog
        v-if="!!hcCaseFlight && isEnableDialogCancel"
        :isOpen="isOpenDialogCancel"
        :id="hcCaseFlight.id"
        @dialogClosed="isEnableDialogCancel = false"
        @closeDialog="isOpenDialogCancel = false"
        @cancelSuccess="cancelSuccess"
      />
    </template>
  </detail-template>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hcCaseMasterService from "../../../services/hcCaseMasterService";
import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
import hcStateToStateService from "../../../services/hcStateToStateService";
import goBackMixin from "../../../mixins/goBackMixin";
import constants from "../../../constants";
import h from "../../../services/h";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import HcMaybayUpload from "./hc-maybay-upload";
import HcMaybayUsers from "./hc-maybay-users";
import HcMaybayRoutes from "./hc-maybay-routes";
import HcMaybayState from "./hc-maybay-state";
import hcCaseFlightService from "../../../services/maybay/hcCaseFlightService";
import HcMaybayUploadReadonly from "./hc-maybay-upload-readonly";
import HcMaybayUserRouteReadonly from "./hc-maybay-user-route-readonly";
import HcDieuxeApproveDialog from "../dieuxe/hc-dieuxe-approve-dialog";
import HcMaybayApproveDialog from "./hc-maybay-approve-dialog";
import HcMaybayUpdateDialog from "./hc-maybay-update-dialog";
import HcMaybayCancelDialog from "./hc-maybay-cancel-dialog";
import HcMaybayRejectDialog from "./hc-maybay-reject-dialog";
import utils from "../../../services/utils";

export default {
  name: "hc-dieuxe-detail",
  mixins: [handleRequestErrorMixin, goBackMixin],
  components: {
    HcMaybayRejectDialog,
    HcMaybayCancelDialog,
    HcMaybayUpdateDialog,
    HcMaybayUserRouteReadonly,
    HcMaybayApproveDialog,
    HcDieuxeApproveDialog,
    HcMaybayUploadReadonly,
    HcMaybayState,
    HcMaybayRoutes,
    HcMaybayUsers,
    HcMaybayUpload,
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    Multiselect: () => import("vue-multiselect")
  },

  data() {
    return {
      hcCaseFlight: null,
      hcFlowInstance: null,
      hcCaseMaster: null,
      nextHcStateToStateActions: null,
      requestUserDeptRole: null,
      form: {
        requestName: null,
        requestContent: null,
        note: null
      },
      rules: {},

      isAbleToCapNhat: false,
      isAbleToHuy: false,
      isAbleToPheDuyet: false,
      isAbleToTuChoi: false,

      isOpenDialogApprove: false,
      isEnableDialogApprove: false,
      isOpenDialogReject: false,
      isEnableDialogReject: false,
      isOpenDialogCancel: false,
      isEnableDialogCancel: false,
      isOpenDialogUpdate: false,
      isEnableDialogUpdate: false,

      HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE
    };
  },

  computed: {
    caseMasterId() {
      return this.$route.params.id;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
  },

  watch: {
    caseMasterId() {
      this.reloadPage();
    },

    isOpenDialogApprove(newValue) {
      if (newValue) this.isEnableDialogApprove = newValue;
    },

    isOpenDialogReject(newValue) {
      if (newValue) this.isEnableDialogReject = newValue;
    },

    isOpenDialogCancel(newValue) {
      if (newValue) this.isEnableDialogCancel = newValue;
    },

    isOpenDialogUpdate(newValue) {
      if (newValue) this.isEnableDialogUpdate = newValue;
    }
  },

  created() {
    this.initSelectOptions();
    this.initPage();
  },

  methods: {
    exportReport() {
      let query = {
        userDeptRoleId: this.userDeptRoleId,
        hcCaseMasterId: this.caseMasterId
      };
      utils.exportReport(constants.REPORT.MAY_BAY.REPORT_URL, query);
    },

    afterSubmitSuccess() {
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    update() {
      this.isOpenDialogUpdate = true;
    },

    updateSuccess() {
      this.isOpenDialogUpdate = false;
      this.afterSubmitSuccess();
    },

    loadRequestUserDeptRole() {
      return userDeptRoleViewService
        .findRequesterForHc(this.caseMasterId)
        .then(response => (this.requestUserDeptRole = response.data));
    },

    cancel() {
      this.isOpenDialogCancel = true;
    },

    cancelSuccess() {
      this.isOpenDialogCancel = false;
      this.afterSubmitSuccess();
    },

    rejectSuccess() {
      this.isOpenDialogReject = false;
      this.afterSubmitSuccess();
    },

    reject() {
      this.isOpenDialogReject = true;
    },

    approve() {
      this.isOpenDialogApprove = true;
    },

    approveSuccess() {
      this.isOpenDialogApprove = false;
      this.afterSubmitSuccess();
    },

    async reloadPage() {
      await this.initPage();
    },

    initSelectOptions() {
    },

    async initPage() {
      await this.loadHcCaseFlight();
      await this.loadHcCaseMaster();
      await this.loadHcFlowInstance();
      await this.loadNextActions();
      await this.loadRequestUserDeptRole();
      this.initActions();
      this.initFormForEdit();
    },

    initFormForEdit() {
      this.bindDataToForm(this.form);
    },

    bindDataToForm(form) {
      form.requestName = this.hcCaseFlight.requestName;
      form.requestContent = this.hcCaseFlight.requestContent;
      form.note = this.hcCaseFlight.note;
    },

    initActions() {
      this.isAbleToCapNhat = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.CAP_NHAT
      );
      this.isAbleToHuy = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.HUY
      );
      this.isAbleToPheDuyet = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.PHE_DUYET
      );
      this.isAbleToTuChoi = this.isEnableAction(
        constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.TU_CHOI
      );
    },

    isEnableAction(actionCode) {
      return h.exists(
        this.nextHcStateToStateActions,
        hcStateToState => hcStateToState.actionCode === actionCode
      );
    },

    loadNextActions() {
      return hcStateToStateService
        .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
        .then(response => (this.nextHcStateToStateActions = response.data));
    },

    loadHcFlowInstance() {
      return hcFlowInstanceService
        .findById(this.hcCaseMaster.flowInstanceId)
        .then(response => (this.hcFlowInstance = response.data));
    },

    loadHcCaseMaster() {
      return hcCaseMasterService
        .findById(this.hcCaseFlight.hcCaseMasterId)
        .then(response => (this.hcCaseMaster = response.data));
    },

    loadHcCaseFlight() {
      return hcCaseFlightService
        .findByHcCaseMaster(this.caseMasterId)
        .then(response => (this.hcCaseFlight = response.data));
    },

    backListPage() {
      this.goBack();
    }
  }
};
</script>

<style scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  margin-left: 10px;
}

.tableHeader {
  height: 35px;
}

tr {
  text-align: center;
}

th {
  font-size: 13px;
  color: black;
  border-bottom: 1px solid #e3e8ee;
}

table {
  border: 1px solid #e3e8ee;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-detail.vue